import "./Venues.scss";

import exportIcon from "../../assets/images/icons/upload.svg";
import sort from "../../assets/images/icons/sort.svg";
import search from "../../assets/images/icons/Search.svg";
import edit from "../../assets/images/icons/edit-purple.svg";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import axios from "axios";
import ReactPaginate from "react-paginate";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function Venues() {
    const tabs = ["name", "category", "location"];
    const titles = [
        "Name",
        "Category",
        "Working time",
        "Location",
        "Website",
        "Price",
        "About",
        "Followers",
        "Check-ins",
    ];

    const navigate = useNavigate();

    //GETTING INITIAL VENUES ============================================================

    const [venues, setVenues] = useState([]);

    useEffect(() => {
        const getVenues = async () => {
            try {
                const response = await axios.get("https://zona-app-server-584d567d8841.herokuapp.com/venues");
                setVenues(response.data);
            } catch (error) {
                console.log(`venues get request didn't work. error: ${error}`);
            }
        };
        getVenues();
    }, []);

    //SEARCH FUNCTIONALITY =============================================================

    const [activeSearch, setActiveSearch] = useState(false);
    const [displayVenue, setDisplayVenue] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    function handleChange(event) {
        setActiveSearch(true);
        setSearchQuery(event.target.value);

        const filtered = venues.filter(
            (item) =>
                item.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.mainCat.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.category_name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.city.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.state.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.about.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.price.includes(event.target.value)
        );
        setFilteredData(filtered);
    }

    useEffect(() => {
        activeSearch ? setDisplayVenue(filteredData) : setDisplayVenue(venues);
    }, [activeSearch, filteredData, venues]);

    function handleExitSearch() {
        setActiveSearch(false);
        setSearchQuery("");
    }

    //PAGINATION =======================================================================

    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(8);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = displayVenue.slice(indexOfFirstPost, indexOfLastPost);

    const paginate = ({ selected }) => {
        setCurrentPage(selected + 1);
    };

    //HANDLING SORTS ==================================================================

    const [nameSortClicks, setNameSortClicks] = useState(1);
    const [catSortClicks, setCatSortClicks] = useState(1);
    const [locationSortClicks, setLocationSortClicks] = useState(1);

    function handleSortClick(by) {
        switch (by) {
            case "name":
                setNameSortClicks((prevCount) => prevCount + 1);
                applyNameFilter();
                break;
            case "category":
                setCatSortClicks((prevCount) => prevCount + 1);
                applyCategoryFilter();
                break;
            case "location":
                setLocationSortClicks((prevCount) => prevCount + 1);
                applyLocationFilter();
                break;
            default:
                break;
        }
    }

    function applyNameFilter() {
        let filteredVenues;

        switch (nameSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayVenue].sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
                filteredVenues = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayVenue].sort((a, b) => {
                    return b.name.localeCompare(a.name);
                });
                filteredVenues = sortedByNameZA;
                break;
            case 3:
                filteredVenues = venues;
                setNameSortClicks(1);
                break;
            default:
                filteredVenues = venues;
                break;
        }

        setDisplayVenue(filteredVenues);
    }

    function applyCategoryFilter() {
        let filteredVenues;

        switch (catSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayVenue].sort((a, b) => {
                    return a.category.localeCompare(b.category);
                });
                filteredVenues = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayVenue].sort((a, b) => {
                    return b.category.localeCompare(a.category);
                });
                filteredVenues = sortedByNameZA;
                break;
            case 3:
                filteredVenues = venues;
                setCatSortClicks(1);
                break;
            default:
                filteredVenues = venues;
                break;
        }

        setDisplayVenue(filteredVenues);
    }

    function applyLocationFilter() {
        let filteredVenues;

        switch (locationSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayVenue].sort((a, b) => {
                    return a.city.localeCompare(b.city);
                });
                filteredVenues = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayVenue].sort((a, b) => {
                    return b.city.localeCompare(a.city);
                });
                filteredVenues = sortedByNameZA;
                break;
            case 3:
                filteredVenues = venues;
                setLocationSortClicks(1);
                break;
            default:
                filteredVenues = venues;
                break;
        }

        setDisplayVenue(filteredVenues);
    }

    //EXPORTING VENUES DATA ==========================================================

    function handleExportDataClick() {
        try {
            const csvRows = [];

            const headers = Object.keys(venues[0]);
            csvRows.push(headers.join(","));

            for (const row of venues) {
                const values = headers.map((header) => {
                    const escapedValue = row[header].toString().replace(/"/g, '\\"');
                    return `"${escapedValue}"`;
                });
                csvRows.push(values.join(","));
            }

            const csvContent = csvRows.join("\n");
            const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

            saveAs(csvBlob, "venues_data.csv");
        } catch (error) {
            console.error("Error converting JSON to CSV:", error);
        }
    }

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="venues">
                        <div className="venues__top">
                            <h1 className="venues__top-heading">Venues</h1>

                            <div className="venues__top-buttons">
                                <div className="venues__top-buttons-search">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <label htmlFor="search">
                                            <img
                                                src={search}
                                                className="venues__top-buttons-search-icon"
                                                alt="magnifying glass"
                                            ></img>
                                        </label>
                                        <input
                                            id="search"
                                            type="text"
                                            className="venues__top-buttons-search-input"
                                            placeholder="Search..."
                                            value={searchQuery}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {activeSearch && (
                                        <div onClick={handleExitSearch} className="venues__top-buttons-search-x">
                                            <p className="venues__top-buttons-search-x-text">X</p>
                                        </div>
                                    )}
                                </div>
                                <Link to="/venues/add" className="venues__top-buttons-colorful">
                                    Add new venue +
                                </Link>
                                <button onClick={handleExportDataClick} className="venues__top-buttons-clear">
                                    <p className="venues__top-buttons-clear-text">Export data</p>
                                    <img
                                        src={exportIcon}
                                        className="venues__top-buttons-clear-icon"
                                        alt="export data"
                                    ></img>
                                </button>
                            </div>
                        </div>

                        <div className="venues__sorts">
                            {tabs.map((tab, index) => (
                                <button
                                    onClick={() => handleSortClick(tab)}
                                    key={index}
                                    className="venues__sorts-button"
                                >
                                    <p className="venues__sorts-button-text">Sort by {tab}</p>
                                    <img
                                        className="venues__sorts-button-icon"
                                        src={sort}
                                        alt="three cascasding horizontal lines"
                                    ></img>
                                </button>
                            ))}
                        </div>

                        <table className="venues__table">
                            <thead className="venues__table-top">
                                <tr className="venues__table-top-headings">
                                    {titles.map((title, index) => (
                                        <th key={index} className="venues__table-top-headings-heading" scope="col">
                                            {title}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            {venues ? (
                                <tbody className="venues__table-info">
                                    {currentPosts.map((venue) => (
                                        <tr key={venue._id} className="venues__table-info-info">
                                            <td className="venues__table-info-info-text">
                                                {venue.name}
                                                <img
                                                    onClick={() => navigate(`edit/${venue.id}`)}
                                                    src={edit}
                                                    className="venues__table-info-info-text-icon"
                                                    alt="purple pen"
                                                ></img>
                                            </td>
                                            <td className="venues__table-info-info-text">{venue.category}</td>
                                            <td className="venues__table-info-info-text">{venue.hours}</td>
                                            <td className="venues__table-info-info-text">
                                                {venue.city + ", " + venue.state}
                                            </td>

                                            <td className="venues__table-info-info-text">
                                                <a href={venue.url}>website</a>
                                            </td>
                                            <td className="venues__table-info-info-text">
                                                <p>{venue.price}</p>
                                            </td>
                                            <td className="venues__table-info-info-text venues__table-info-info-text--special">
                                                <div className="truncated">
                                                    <p className="truncated-text">{venue.about}</p>
                                                </div>
                                                <p>...</p>
                                            </td>
                                            <td className="venues__table-info-info-text">{venue.followers}</td>
                                            <td className="venues__table-info-info-text">{venue.checkIns}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <div>Loading...</div>
                            )}
                        </table>
                        <ReactPaginate
                            onPageChange={paginate}
                            pageCount={Math.ceil(venues.length / postsPerPage)}
                            previousLabel={"<"}
                            nextLabel={">"}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            containerClassName={"pagination"}
                            pageLinkClassName={"page-number"}
                            previousLinkClassName={"page-number-prev"}
                            nextLinkClassName={"page-number-next"}
                            activeLinkClassName={"active-number"}
                        />
                    </section>
                </article>
            </div>
        </main>
    );
}

export default Venues;
